<template lang="pug">
  label.label(v-if="id && label" :for="id")
    | {{ label }}
    | #[span.label__info(v-if="lblInfo") {{ lblInfo }}]
</template>
<script>
export default {
  name: 'Label',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    lblInfo: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .label {
    color: #444444;

    &__info {
      color: #747474;
      font-family: $rubik-font-family;
      font-size: 14px;
      font-weight: normal;
      margin-left: 6px;
    }
  }
</style>
